export class Guid {
    isGuidEmpty(guid:string)
    {
        return guid == "00000000-0000-0000-0000-000000000000";
    }
}
